import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

import useGetSRBMDetail from 'hooks/Traps/SRBMTraps/useGetSRBMDetail';
import DeviceBreadCrump from 'components/DevicesDetail/DeviceDetailBreadCrump';
import { TrapTableType } from 'components/TrapsTables/trapTables';
import InfoCardsRow from 'components/DevicesDetail/SRBM/InfoCardsRow/InfoCardsRow';
import SideTableWithData from 'components/DevicesDetail/SRBM/SideTableWithData/SideTableWithData';
import CombinedChartSRBM from 'components/DevicesDetail/SRBM/SRBMSignalsChart/ChartCard';
import WorkTimeCard from 'components/DevicesDetail/SRBM/InfoCardsRow/workTimeCard';
import SBSMonitoringHistoryCard from 'components/DevicesDetail/SRBM/SBSMonitoringHistoryCard/SBSMonitoringHistoryCard';
import SRBMTrapHistoryCard from 'components/DevicesDetail/SRBM/SRBMTrapCapture/SRBPTrapHistoryCard';

const SRBMDetail = () => {
  const { slug } = useParams();
  const { data, isLoading, refetch } = useGetSRBMDetail(slug || '');

  useEffect(() => {
    refetch();
  }, [slug, refetch]);

  return (
    <div className="page-content bg-light">
      <div className="container-fluid">
        <DeviceBreadCrump
          dropDownData={data?.select_trap_dropdow_data || null}
          objSlug={data?.object?.slug || ''}
          objName={data?.object?.name || ''}
          sq={data?.sequence_number || ''}
          sn={data?.serial_number || ''}
          deviceType={TrapTableType.SmartRodenBaitModule}
          isLoading={isLoading}
          slug={slug || ''}
          deviceName="trap"
        />

        <InfoCardsRow data={data || null} isLoading={isLoading} />

        <div className="row">
          <div className="col-xxl-3">
            <WorkTimeCard data={data || null} isLoading={isLoading} />
            <SideTableWithData data={data || null} isLoading={isLoading} slug={slug || ''} />
          </div>
          <div className="col-xl-9">
            <CombinedChartSRBM slug={slug || ''} />
          </div>
        </div>
        <SRBMTrapHistoryCard slug={slug || ''} type="srbm" />
        <SBSMonitoringHistoryCard slug={slug || ''} />
      </div>
    </div>
  );
};

export default SRBMDetail;
